class FrontpageCollectionImages extends HTMLElement {
  constructor() {
    super();
    this.intervalTime = 2500;
    this.alternateTransition = true;
    this.verticalImages = null;
    this.horizontalImages = null;
    this.currentVertical = 1;
    this.currentHorizontal = 1;
    this.lastVertical = false;
    this.lastHorizontal = false;
    this.verticalIntervalId = null;
    this.horizontalIntervalId = null;
  }

  connectedCallback() {
    this.intervalTime = this.getAttribute('data-interval')
      ? Number(this.getAttribute('data-interval'))
      : 2500;
    this.alternateTransition = this.getAttribute('data-alternate') === 'true';
    this.verticalImages = this.querySelectorAll('.image-wrapper--vertical');
    this.horizontalImages = this.querySelectorAll('.image-wrapper--horizontal');
    this.currentVertical = 1;
    this.currentHorizontal = 1;
    this.lastVertical = false;
    this.lastHorizontal = false;
    this.verticalIntervalId = null;
    this.horizontalIntervalId = null;

    if (this.verticalImages?.length > 1) {
      this.verticalIntervalId = setInterval(() => {
        this.verticalImages.forEach((img) => {
          const dataIndex = img.getAttribute('data-index');
          const dataLastItem = img.getAttribute('data-last-item') !== null;
          if (this.currentVertical === Number(dataIndex)) {
            img.classList.add('opacity-100');
            img.classList.remove('opacity-0');
            this.lastVertical = dataLastItem;
          } else {
            img.classList.remove('opacity-100');
            img.classList.add('opacity-0');
          }
        });
        this.currentVertical = this.lastVertical ? 0 : this.currentVertical + 1;
      }, this.intervalTime);
    }

    if (this.horizontalImages?.length > 1) {
      setTimeout(
        () => {
          this.horizontalIntervalId = setInterval(() => {
            this.horizontalImages.forEach((img) => {
              const dataIndex = img.getAttribute('data-index');
              const dataLastItem = img.getAttribute('data-last-item') !== null;
              if (this.currentHorizontal === Number(dataIndex)) {
                img.classList.add('opacity-100');
                img.classList.remove('opacity-0');
                this.lastHorizontal = dataLastItem;
              } else {
                img.classList.remove('opacity-100');
                img.classList.add('opacity-0');
              }
            });
            this.currentHorizontal = this.lastHorizontal
              ? 0
              : this.currentHorizontal + 1;
          }, this.intervalTime);
        },
        this.alternateTransition ? this.intervalTime / 2 : 0
      );
    }
  }

  disconnectedCallback() {
    clearInterval(this.verticalIntervalId);
    clearInterval(this.horizontalIntervalId);
  }
}

if (!customElements.get('frontpage-collection-images')) {
  customElements.define(
    'frontpage-collection-images',
    FrontpageCollectionImages
  );
}
